import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Obstacle } from '@thive/fddm-types';
import { Stack } from '@mui/system';

import { Accordion } from '@common/components/Accordion';

import Appearance from './obstacle/Appearance';
import Height from './obstacle/Height';
import { UserPreferenceName } from '@/modules/userPreferences';
import {
  FIELDS_PADDING_BOTTOM,
  FIELDS_SPACING,
  PANEL_ACCORDION_SX,
} from '@/modules/common/constants/propertyPanel';
interface Props {
  selectedObstacles: Obstacle[];
}

function ObstacleParametersComponent({ selectedObstacles }: Props) {
  const { t } = useTranslation();
  const title =
    selectedObstacles.length === 1
      ? t<string>('interface:properties.obstacle.title', 'Obstacle')
      : t<string>(
          'interface:properties.obstacle.title_plural',
          `Obstacles (${selectedObstacles.length})`,
          { amount: selectedObstacles.length },
        );

  return (
    <Accordion
      persistId={UserPreferenceName.ACCORDION_PROPERTY_PANEL_OBSTACLE}
      title={title}
      unmountOnExit
      sx={PANEL_ACCORDION_SX}
    >
      <Stack direction='column' spacing={FIELDS_SPACING} pb={FIELDS_PADDING_BOTTOM}>
        <Appearance selectedObstacles={selectedObstacles} />
        <Height selectedObstacles={selectedObstacles} />
      </Stack>
    </Accordion>
  );
}

export const ObstacleParameters = memo(ObstacleParametersComponent);
